import * as React from 'react';

import EmptyStubContent from '../EmptyStubContent';

const EmptyInsight: React.FC = () => {
  return (
    <EmptyStubContent
      title="Выберите инсайт"
      text="Выберите инсайт из дерева слева для просмотра краткого содержания"
    />
  );
};

export default EmptyInsight;
